module.exports = __webpack_public_path__ + "static/assets/d210fd7cfce0e13d33483133060f7196.jpg";